import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticatedUserResolverService } from '@aveva/connect-web-core';
import { AuthenticatedUserAccountResolverService } from 'erm-sdk';
import { ErmCapabilityGuard } from './erm-capability.guard';
import { HomeComponent } from './pages/home/home.component';
import { InfoComponent } from './pages/info/info.component';
import { LaunchErrorComponent } from './pages/launch/launch-error.component';
import { LaunchNativeComponent } from './pages/launch/launch-native.component';
import { LaunchComponent } from './pages/launch/launch.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { LayoutComponent } from './components/layout/layout.component';

const routes: Routes = [
  {
    path: 'erm',
    component: LayoutComponent,
    resolve: {
      user: AuthenticatedUserResolverService,
      account: AuthenticatedUserAccountResolverService
    },
    canActivate: [ErmCapabilityGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'settings',
        component: SettingsComponent
      },
      {
        path: 'launch/client/:envId',
        component: LaunchComponent,
        data: {
          clientType: 'auto',
          fleetKind: 'client'
        }
      },
      {
        path: 'launch/client/:envId/browser',
        component: LaunchComponent,
        data: {
          clientType: 'browser',
          fleetKind: 'client'
        }
      },
      {
        path: 'launch/client/:envId/native',
        component: LaunchComponent,
        data: {
          clientType: 'native',
          fleetKind: 'client'
        }
      },
      {
        path: 'launch/support/:envId',
        component: LaunchComponent,
        data: {
          clientType: 'auto',
          fleetKind: 'support'
        }
      },
      {
        path: 'launch/support/:envId/browser',
        component: LaunchComponent,
        data: {
          clientType: 'browser',
          fleetKind: 'support'
        }
      },
      {
        path: 'launch/support/:envId/native',
        component: LaunchComponent,
        data: {
          clientType: 'native',
          fleetKind: 'support'
        }
      },
      {
        path: 'launch/:envId/error',
        component: LaunchErrorComponent
      },
      {
        path: 'launch/:envId/error/:errorCode',
        component: LaunchErrorComponent
      },
      {
        path: 'launch/client/:envId/native/:streamingUrl',
        component: LaunchNativeComponent,
        data: {
          fleetKind: 'client'
        }
      },
      {
        path: 'launch/support/:envId/native/:streamingUrl',
        component: LaunchNativeComponent,
        data: {
          fleetKind: 'support'
        }
      },
      {
        path: 'info/:envId',
        component: InfoComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ErmCapabilityRoutingModule { }
